/** ResizeObserver that defers callbacks to the next frame (avoids loop errors on layout/unmount). */
export function observeElementResize(element, onResize) {
  if (!element || typeof ResizeObserver === 'undefined') {
    return () => {};
  }

  let frameId = 0;
  let disconnected = false;

  const ro = new ResizeObserver(() => {
    if (disconnected) return;
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(() => {
      if (disconnected) return;
      onResize();
    });
  });

  ro.observe(element);

  return () => {
    disconnected = true;
    cancelAnimationFrame(frameId);
    ro.disconnect();
  };
}
